// eslint-disable-next-line @typescript-eslint/no-var-requires
const routes = require('src/routing/routes').default

export const staticPages = {
    Shipments: {
        path: routes.shipments.path,
        comp: () => import('./ShipmentsPage'),
        to: (): string => routes.shipments.path
    },
    Help: {
        path: routes.help.path,
        comp: () => import('src/business/static-pages/HelpPage'),
        to: (): string => routes.help.path
    },
    Gdpr: {
        path: routes.gdpr.path,
        comp: () => import('src/business/static-pages/GdprPage'),
        to: (): string => routes.gdpr.path
    },
    StorePolicy: {
        path: routes.storePolicy.path,
        comp: () => import('src/business/static-pages/StorePolicyPage'),
        to: (): string => routes.storePolicy.path
    },
    Franchising: {
        path: routes.franchising.path,
        comp: () => import('src/business/static-pages/FranchisingPage'),
        to: (): string => routes.franchising.path
    }
}
